export const Strings = {
	QUESTION_ANSWER: 'question-answer',
	MULTIPLE_CHOICE: 'multiple-choice',
	SECTION: 'section',
	UPLOAD_FILE: 'file-question',
};
